export interface GetAppAveragesRequestParamsDto {
    endDate: string;
    appId: string;
}